/**
 * RealtimeConsoleCommonUsagePanel — 공통 모듈 시연 패널 (§6.6)
 * biz-foundation §4.11 의무 적용
 */
import { useTranslation } from 'react-i18next';
import { CommonUsagePanel } from '../../_shared/CommonUsagePanel';
import type { CommonUsageItem } from '../../_shared/CommonUsagePanel';

const ITEMS: CommonUsageItem[] = [
  {
    module: 'eraf-integration-websocket (C063)',
    moduleColor: 'purple',
    api: 'WebSocketAutoConfiguration',
    role: 'STOMP 인프라 활성화 (opt-in true)',
    snippet: 'eraf.integration.websocket.enabled: true',
  },
  {
    module: 'eraf-integration-websocket (C063)',
    moduleColor: 'purple',
    api: 'WebSocketStompConfig',
    role: '엔드포인트/broker/heartbeat 표준 설정',
    snippet: '(재사용 — biz 코드 0줄)',
  },
  {
    module: 'eraf-integration-websocket (C063)',
    moduleColor: 'purple',
    api: 'StompAuthChannelInterceptor',
    role: 'CONNECT JWT 인증 → Principal',
    snippet: 'connectHeaders: { Authorization: Bearer <token> }',
  },
  {
    module: 'eraf-security (C028)',
    moduleColor: 'yellow',
    api: 'JwtAuthenticationService.verify()',
    role: 'CONNECT 토큰 검증 (C063 내부 위임)',
    snippet: '(자동 — biz 코드 0줄)',
  },
  {
    module: 'spring-messaging (C063 transitive)',
    moduleColor: 'blue',
    api: 'SimpMessagingTemplate.convertAndSend',
    role: '서버→클라이언트 broadcast',
    snippet: 'broker.convertAndSend("/topic/console.lobby", view)',
  },
  {
    module: 'eraf-core (C002)',
    moduleColor: 'blue',
    api: 'ApiResponse<ConsoleHealth>',
    role: 'REST 보조 응답 래핑',
    snippet: 'return ApiResponse.success(health)',
  },
  {
    module: 'eraf-core (C001)',
    moduleColor: 'blue',
    api: 'BusinessException(RTCON-413-001)',
    role: '메시지 길이 초과 차단',
    snippet: 'throw new BusinessException(MESSAGE_TOO_LONG)',
  },
  {
    module: 'eraf-security (C030)',
    moduleColor: 'yellow',
    api: '@HasPermission("REALTIME_CONSOLE_READ")',
    role: 'REST 보조 권한 (이중 방어)',
    snippet: '@HasPermission("REALTIME_CONSOLE_READ") sessions()',
  },
  {
    module: 'eraf-security (C029)',
    moduleColor: 'yellow',
    api: 'SecurityChainCustomizer + PathPolicy',
    role: '/realtime-console/** + /ws/** AUTHENTICATED',
    snippet: 'PathPolicy.authenticated("/api/eraf/ws/**")',
  },
  {
    module: 'eraf-swagger (C037)',
    moduleColor: 'green',
    api: '@ApiSuccessResponse',
    role: 'REST 보조 OpenAPI 문서화',
    snippet: '@ApiSuccessResponse(responses=ConsoleHealth.class)',
  },
  {
    module: 'eraf-actuator (C069)',
    moduleColor: 'green',
    api: 'HttpRequestMetricsFilter',
    role: 'REST 보조 p95 SLO 측정',
    snippet: '(별도 코드 없음 — 자동)',
  },
];

export function RealtimeConsoleCommonUsagePanel() {
  const { t } = useTranslation();

  return (
    <CommonUsagePanel
      items={ITEMS}
      title={t('realtimeConsole.commonUsage.title')}
      subtitle={t('realtimeConsole.commonUsage.description')}
    />
  );
}
